module.exports = __webpack_public_path__ + "static/media/arrow.a400f21a.svg";